import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=417c3f7f&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=417c3f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417c3f7f",
  null
  
)

export default component.exports